import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { AiCreditsBillingData } from "@circle-react/types/UsageBilling";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";

const balance = () =>
  reactQueryGet<AiCreditsBillingData>(internalApi.credits.balance());

export const creditsApi = {
  balance,
};
